/**
 *    SESSION REPOSITORY
 *
 * 		REACT NOTE: trimmed this down to set/get browser session objects
 * 		no longer using this as an in-memory User / Session store (see ng.delegate)
 * 		trying to eliminitate multiple locations for stored data only into ng.delegate
 */

import validSvc from '../validSvc';
import sessionRepo from './sessionRepo';
import { TableFilters, TblPagination, TableViewState, TblSort, TblFlt } from '../table/table.types';
import { tableSortVM } from '../table/table_view_models';
import { stripAwayFormErrors } from '../table/utils/stripAwayFormErrors';

const VIEWSTATE_TABLE_PREFIX = 'vst-';

const viewStateRepo = {
    setTable,
    getTable,
    clearTable,
    getForm,
    setForm,
    clearForm,
};

function setTable(keyName: string, flt: TableFilters, paging: TblPagination, sort: TblSort): void {
    if (validSvc.isText(keyName) && !!flt && !!paging && sort) {
        const vs = {
            flt: flt,
            paging: paging,
            sort: sort,
        } as TableViewState;

        sessionRepo.set(VIEWSTATE_TABLE_PREFIX + keyName, vs);
    }
}

function getTable(keyName: string, cols?: string[], filters?: TblFlt[]): TableViewState | null {
    if (validSvc.isText(keyName)) {
        let vs = sessionRepo.get(VIEWSTATE_TABLE_PREFIX + keyName);
        if (vs == null) {
            return null;
        }
        vs = vs as TableViewState;

        // check flt / sort against view columns
        if (Array.isArray(cols) && (!!vs.flt || !!vs.sort)) {
            const adjustFlt = {};
            let foundSortCol = false;
            cols.forEach(col => {
                const presetFilter = filters?.find(f => f.key === col);

                if (presetFilter) {
                    adjustFlt[col] = presetFilter.val;
                }

                if (!!vs.flt && vs.flt.hasOwnProperty(col) && typeof vs.flt[col] !== 'undefined') {
                    adjustFlt[col] = vs.flt[col];
                }
                if (!foundSortCol && !!vs.sort && vs.sort.col == col) {
                    foundSortCol = true;
                }
            });
            vs.flt = adjustFlt;
            vs.sort = foundSortCol ? vs.sort : tableSortVM();
        }

        return vs;
    }

    return null;
}

function clearTable(keyName: string): void {
    if (validSvc.isText(keyName)) {
        sessionRepo.clearKey(VIEWSTATE_TABLE_PREFIX + keyName);
    }
}

function getForm(keyName: string): any | null {
    if (validSvc.isText(keyName)) {
        const vs = sessionRepo.get(VIEWSTATE_TABLE_PREFIX + keyName);
        if (vs === null) {
            return null;
        }
        return vs;
    }

    return null;
}

// Removes a form's state from session storage
function clearForm(keyName: string): void {
    if (validSvc.isText(keyName)) {
        sessionRepo.clearKey(VIEWSTATE_TABLE_PREFIX + keyName);
    }
}

function setForm(keyName: string, formState: object, noErrorStrip?: boolean): void {
    if (!validSvc.isText(keyName) || !!!formState) {
        return;
    }

    // by default strip form errors
    const saveForm = !!noErrorStrip ? formState : stripAwayFormErrors(formState);
    sessionRepo.set(VIEWSTATE_TABLE_PREFIX + keyName, saveForm);
}

export default viewStateRepo;
